import React from 'react';
import { connect } from 'react-redux';
import { availableSlotsConfig } from '../../../entity/Jobs/availableSlotsConfig';
import MasterComponent from '../../../components/Forms';

const AvailableSlots: React.FC = () => {


  return <MasterComponent config={availableSlotsConfig} />
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.app.isAuthenticated,
  user: state.app.user,
});

export default connect(mapStateToProps)(AvailableSlots);
